
import React, {useState, useContext} from 'react';
import {Form, Formik} from 'formik';
import {Button, Grid, TextField, FormHelperText} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../../../../util/ErrorBoundaryForComponents';
import SearchEventTacticTable from '../SearchEventTactics/SearchEventTacticTable';
import {ThemeContext} from '../../../../../../themes/ThemeProvider';
import GuiAutoComplete from '../../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../../components/FormComponents/GuiTextField';

const SearchEventTactics = ({
  setSelectedEventTrigger,
  selectedEventTrigger,
  isEventTriggerGroup,
  eventType,
  cardSpace,
  setSearchEventTactics,
  searchEventTactics,
  handleEventTacticSearch,
  tacticValue,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState({});
  const [saveData, setSaveData]=useState(selectedEventTrigger ? selectedEventTrigger :[]);
  const StatusOptions = [{key: 'N', value: 'Completed'}];

  // set search data(2700486402)
  const handleSubmit = (data) => {
    setSearchData(data);
    setSubmit(true);
  };
  // form initial values(2700486402)
  const initialValues = {
    code: '',
    description: '',
    mode: '',
    isDraft: {key: 'N', value: 'Completed'},
  };

  // form field valiation(2700486402)

  // reset form data(2700486402)
  const onClear = () => {
    const data = {
      code: '',
      description: '',
      mode: '',
      isDraft: {key: 'N', value: 'Completed'},
    };
    setSearchData(data);
  };

  return (
    <div className={cardSpace ? 'col' : ''}>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        enableReinitialize
      >
        {(props) => {
          const {touched, errors, values, handleChange, resetForm, handleBlur, setFieldValue} =
            props;
          return (
            <div className={`standard-field-textfields new-standard-textfields`}>
              <Form autoComplete="off" noValidate>
                <ErrorBoundaryForComponents>
                  <Grid container spacing={2}>
                    <Grid item xs={6} md={3} className="form-group">
                      <TextField
                        margin="dense"
                        variant="outlined"
                        className={` ${classes.labelName}`}
                        placeholder={`Enter Trigger Name`}
                        label="Trigger Name"
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        name="code"
                        value={values?.code}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched.code}
                        error={Boolean(touched.code && errors.code)}
                      />
                      <FormHelperText>{touched.code && errors.code && errors.code} </FormHelperText>
                    </Grid>
                    <Grid item xs={6} md={6} className="form-group ">
                      <TextField
                        className={` ${classes.labelName}`}
                        margin="dense"
                        variant="outlined"
                        name="description"
                        placeholder={`Enter Trigger Description`}
                        label="Trigger Description"
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        value={values.description}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6} md={3} xl={3} className="form-group">
                      <GuiAutoComplete
                        classes={{
                          popper: classes.popper,
                          option: classes.option,
                        }}
                        name="isDraft"
                        id="isDraft"
                        size="small"
                        options={StatusOptions}
                        disabled
                        required
                        value={values.isDraft}
                        getOptionLabel={(option) => {
                          return option && option?.value;
                        }}
                        onChange={(e, value) => {
                          handleChange(e);
                          setFieldValue('isDraft', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              className={` ${classes.labelName}`}
                              variant="outlined"
                              margin="dense"
                              // InputLabelProps={{ shrink: true }}
                              label="Status"
                              placeholder="Select Status"
                            />
                          </div>
                        )}
                      />
                    </Grid>
                    <Grid item xs={6} md={12} xl={12} className="form-group">
                      <div className="form-row">
                        <div className="col-md-7">
                          <div className="d-flex  justify-content-end">
                            <Button
                              variant="outlined"
                              className={`reset-btn mr-1 ${classes.buttonRoot}`}
                              onClick={() => {
                                setSubmit(true);
                                resetForm();
                                onClear();
                                !selectedEventTrigger?.length > 0 && setSaveData && setSaveData([]);
                              }}
                            >
                          Reset
                            </Button>
                            <Button
                              variant="outlined"
                              type="submit"
                              className={`search-btn ml-1 ${classes.buttonRoot}`}
                            >
                          Search
                            </Button>
                          </div>
                        </div>
                        <div className="col-md-5 d-flex  justify-content-end">
                          <div className="d-flex  justify-content-end">
                            <Button
                              variant="text"
                              className={`reset-btn mr-1 ${classes.buttonRoot}`}
                              onClick={() => {
                                //  handleEventTacticSearch(),
                                setSearchEventTactics && setSearchEventTactics(false);
                              }}
                            >
                      Close
                            </Button>
                            <Button
                              variant="outlined"
                              className={`search-btn ml-1 ${classes.buttonRoot}`}
                              onClick={() => {
                                setSelectedEventTrigger(saveData);
                                setSearchEventTactics && setSearchEventTactics(false);
                              }}
                            >
                      Save
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </ErrorBoundaryForComponents>
              </Form>
            </div>
          );
        }}
      </Formik>
      <SearchEventTacticTable
        searchData={searchData}
        submit={submit}
        setSubmit={setSubmit}
        setSelectedEventTrigger={setSelectedEventTrigger}
        selectedEventTrigger={selectedEventTrigger}
        isEventTriggerGroup={isEventTriggerGroup}
        eventType={eventType}
        saveData={saveData}
        setSaveData={setSaveData}
      />
    </div>
  );
};
export default SearchEventTactics;
